export default {
      id: "chevron-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }